import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TuiTitle } from '@taiga-ui/core';

@Component({
  selector: 'pxc-choice-picker',
  templateUrl: './choice-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'flex flex-col gap-4',
  },
  imports: [TuiTitle],
})
export class ChoicePickerComponent {
  @Input() title: string;
}
